import { useState } from "react";
import { Col, Modal, Row } from "react-bootstrap";
import PreguntaLinealV2 from "./surveyV2/PreguntaLinealV2";
import PreguntaOpcionMultipleV2 from "./surveyV2/PreguntaOpcionMultipleV2";
import PreguntaSeleccionIndividualV2 from "./surveyV2/PreguntaSeleccionIndividualV2";
import PreguntaTextoV2 from "./surveyV2/PreguntaTextoV2";
import { useEffect } from "react";
import Get from "../../api/Get";
import { ENCUESTA_GET_CLIENT, GET_SURVEY_SIN_TOKEN, SURVEY_SAVE_SIN_TOKEN } from "../../api/Routes";
import Post from "../../api/Post";
import Loading from "../autoagendamientov2/Loading";
import ModalSuccessV2 from "./Common/ModalSuccessV2";
import { getTokenExternal } from "../../utils/getTokenExternal";

export default function SurveyV2({open, setOpen, setCurrentScreen=()=>{}, cita, company={id: 1}}){
    const [question, setQuestion] = useState([])
    const [answer, setAnswer] = useState([])
    const [checkLinealStado, setCheckLinealStado] = useState([])
    const [items, setItems] = useState({
        isSubmiting: false,
        showSuccess: false
    })

    //get la encuesta
    useEffect(() => {
        const fetchApi = async () => {
            try {
                const responseToken = await getTokenExternal(company)
                const token = responseToken.data.access_token
                const response = await Get({url: `${ENCUESTA_GET_CLIENT}/patient`, access_token: token});
                setQuestion(response.data.data.response)
            } catch (error) {   
                console.log(error)
                setQuestion([])
            }
        }
        fetchApi()
    }, [])


    const sendEncuesta = async () =>{
        setItems(prev=>({
            ...prev,
            isSubmiting: true
        }))
        let d = {
            id: parseInt(cita.id),
            surveys: answer
        }     
        try {
            await Post({url: SURVEY_SAVE_SIN_TOKEN, data: d, header: false})
            setCurrentScreen("citaConcluido")
            setItems(prev=>({
                ...prev,
                isSubmiting: false,
                showSuccess: true
            }))
            setOpen(false)
        } catch (error) {
            console.log('error')
            setItems(prev=>({
                ...prev,
                isSubmiting: false,
                showSuccess: false
            }))
        }             
    } 

    const fillAnswer = (obj) =>{
        let findIndex = answer.findIndex(ele=>ele.id===obj.id)
        if(findIndex >= 0){
            let arr = [...answer]
            arr[findIndex] = obj
            setAnswer(arr)
        }else{
            let arr = [...answer]
            arr.push(obj)
            setAnswer(arr)
        }
    }

    const onHandleLinealAnswer = (respuesta, item) =>{        
        let obj = JSON.parse(JSON.stringify(item));
        obj.options = [respuesta]
        fillAnswer(obj)
        let arr = [...checkLinealStado]        
        let findIndex = answer.findIndex(ele=>ele.id===obj.id)
        if(findIndex>=0){
            let findi = arr.findIndex(el=>el.id===answer[findIndex].id)
            if(findi>=0){
                arr[findi] = obj
                setCheckLinealStado(arr)
            }
        }else{
            arr.push(obj)
            setCheckLinealStado(arr)            
        }
    }
    const onHandleMultipleAnswer = (respuesta, checked, item) =>{
        let obj = JSON.parse(JSON.stringify(item))        
        let findIndexObjCreate = answer.findIndex(el=>el.id===item.id)
        if(checked){
            if(findIndexObjCreate>=0){
                obj = answer[findIndexObjCreate]
                obj.options.push(respuesta)
            }else{
                obj.options = [respuesta]
            }
        }else{
            if(findIndexObjCreate>=0){
                let arr = answer[findIndexObjCreate].options.filter(el=>el!==respuesta)
                obj.options = arr
            }   
        }
        fillAnswer(obj)
    }
    //respuesta seleccion individual
    const onHandleIndividualAnswer = (respuesta, item) =>{
        let obj = JSON.parse(JSON.stringify(item))
        let findIndexObjCreate = answer.findIndex(el=>el.id===item.id)
        if(findIndexObjCreate>=0){
            obj = answer[findIndexObjCreate]
            obj.options = [respuesta]
        }else{
            obj.options = [respuesta]
        }
        fillAnswer(obj)
    }
    const onHandleTextoAnswer = (texto, item) =>{
        let obj = item;
        obj.options = [texto]
        //console.log(obj)
        fillAnswer(obj)        
    }

    return (
        <>
            <Modal show={open} onHide={() => setOpen(false)} backdrop="static" keyboard={false} size="lg">
                <Modal.Header closeButton className="border-0">
                </Modal.Header>
                <Modal.Body className="px-5 text-center">    
                    <h5 className="colorLink pb-4">ENCUESTA DE SERVICIO</h5>            
                    <Row>
                        {
                            question.map((item,i)=>(
                                <Col xs="12" md="12" key={i} className="mb-3">
                                    {
                                        item.questionType.nombreTipoPregunta==='Lineal' ?
                                        <PreguntaLinealV2 item={item} onHandleLinealAnswer={onHandleLinealAnswer} checkLinealStado={checkLinealStado}/> :
                                        item.questionType.nombreTipoPregunta==='OpcionMultiple' ?
                                        <PreguntaOpcionMultipleV2 item={item} onHandleMultipleAnswer={onHandleMultipleAnswer}/> :
                                        item.questionType.nombreTipoPregunta==="SeleccionIndividual" ?
                                        <PreguntaSeleccionIndividualV2 item={item} onHandleIndividualAnswer={onHandleIndividualAnswer}/> :
                                        <PreguntaTextoV2 item={item} onHandleTextoAnswer={onHandleTextoAnswer}/>
                                    }
                                </Col>
                            ))
                        }
                        
                    </Row>              
                    <div className="d-flex justify-content-center">
                        {
                            items.isSubmiting ?
                            <Loading /> :
                            <button onClick={sendEncuesta} disabled={answer.length === 0}>Enviar</button>
                        }                    
                    </div>                
                </Modal.Body>
            </Modal>
            <ModalSuccessV2 
                open={items.showSuccess}
                setItems={setItems}
            />
        </>
        
    )
}